import Vue from 'vue'
import { store } from '../store/store.js'
import Router from 'vue-router'


import LoginPage from '@/views/Auth/Login'
import DashboardMain from '@/views/Dashboard/Main'

//Edit Profile
const EditProfileMain = () => import('@/views/Auth/Main')
import EditProfile from '@/views/Auth/EditProfile'

//Error Pages
import NotFound from '@/views/Error/SmallNotFound'
import PageNotFound from '@/views/Error/PageNotFound'

//Highlight
const HighlightMain = () => import('@/views/Dashboard/Highlight/Main')
import Highlight from '@/views/Dashboard/Highlight/Highlight'
import HighlightLabelMaker from '@/views/Dashboard/Highlight/HighlightLabelMaker'
import HighlightOilMaker from '@/views/Dashboard/Highlight/HighlightOilMaker'
import HighlightCustomer from '@/views/Dashboard/Highlight/HighlightCustomer'

//CustomerActivities
const CustomerActivitiesMain = () => import('@/views/Dashboard/CustomerActivities/Main')
import CustomerActivities from '@/views/Dashboard/CustomerActivities/CustomerActivities'

//Consumer Insights
const ConsumerInsightsMain = () => import('@/views/Dashboard/ConsumerInsights/Main')
import ConsumerInsights from '@/views/Dashboard/ConsumerInsights/ConsumerInsights'

//Reports
const ReportsMain = () => import('@/views/Dashboard/Reports/Main')
import ReportCustomer from '@/views/Dashboard/Reports/ReportCustomer2'
import ReportLabelMaker from '@/views/Dashboard/Reports/ReportLabelMaker'
import ReportOilMaker from '@/views/Dashboard/Reports/ReportOilMaker'
import ReportQrCode from '@/views/Dashboard/Reports/ReportQrCode'
import ReportSuspect from '@/views/Dashboard/Reports/ReportSuspect'
import SummaryReport from '@/views/Dashboard/Reports/SummaryReport'
import ReportNotFound from '@/views/Dashboard/Reports/ReportNotFound'

//Settings
const SettingsMain = () => import('@/views/Dashboard/Settings/Main')
import LogHistoryActivity from '@/views/Dashboard/Settings/UserManagement/LogDashboardActivity'
//User Management
const UserManagementMain = () => import('@/views/Dashboard/Settings/UserManagement/Main')
import DashboardUserUM from '@/views/Dashboard/Settings/UserManagement/DashboardUserUM'
import OilMakerAppUM from '@/views/Dashboard/Settings/UserManagement/OilMakerAppUM'
import PenindakanAppUM from '@/views/Dashboard/Settings/UserManagement/PenindakanAppUM'
import CrossClient from '@/views/Auth/CrossClient'



Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    //Login Path
    {
      path : '/',
      redirect : '/login'
    },
    {
      path : '/login',
      name : 'Login',
      component : LoginPage,
      meta : {
        requiresAuth : false
      }
    },
    {
      path: "/cross-client",
      name: "Cross Client",
      component: CrossClient,
      meta: {
          requiresAuth: false,
      },
  },
    
    //Edit Profile
    {
      path : '',
      component : DashboardMain,
      children : [
        {
          path : '/edit-profile',
          name : 'EditProfile',
          component : EditProfile,
          meta : {
            requiresAuth : true,
            sidebar : true
          }
        },
      ]
    },

    //Dashboard Start
    {
      path : '/dashboard',
      name : 'Dashboard',
      component : DashboardMain,
      children : [
        //Default Fallback
        {
          path : '',
          name : 'Dashboard',
          component : NotFound
        },

        //Highlight
        {
          path : 'highlight',
          component : HighlightMain,
          children : [{
            path : '',
            name : 'Highlight',
            component : Highlight
          },{
            path : 'label-maker',
            name : 'HighlightLabelMaker',
            component : HighlightLabelMaker,
            meta : {
              menu : 'Highlight',
              module : 'Label Maker'
            }
          },{
            path : 'oil-maker',
            name : 'HighlightOilMaker',
            component : HighlightOilMaker,
            meta : {
              menu : 'Highlight',
              module : 'Oil Maker'
            }
          },{
            path : 'customer',
            name : 'HighlightCustomer',
            component : HighlightCustomer,
            meta : {
              menu : 'Highlight',
              module : 'Customer'
            }
          }]
        },

        //Activities
        {
          path : 'customer-activities',
          component : CustomerActivitiesMain,
          children : [{
            path : '',
            name : 'CustomerActivities',
            component : CustomerActivities,
            meta : {
              menu : 'Customer Activities',
              module : 'Customer Activities'
            }
          }]
        },

        //Consumer Insights
        {
          path : 'consumer-insights',
          component : ConsumerInsightsMain,
          children : [{
            path : '',
            name : 'ConsumerInsights',
            component : ConsumerInsights
          }]
        },

        //Reports
        {
          path : 'reports',
          component : ConsumerInsightsMain,
          children : [{
            path : '',
            name : 'Reports',
            component : NotFound
          },{
            path : 'customer',
            name : 'ReportCustomer',
            component : ReportCustomer,
            meta : {
              menu : 'Reports',
              module : 'Report Customer'
            }
          },{
            path : 'label-maker',
            name : 'ReportLabelMaker',
            component : ReportLabelMaker,
            meta : {
              menu : 'Reports',
              module : 'Report Label Maker'
            }
          },{
            path : 'oil-maker',
            name : 'ReportOilMaker',
            component : ReportOilMaker,
            meta : {
              menu : 'Reports',
              module : 'Report Oil Maker'
            }
          },{
            path : 'qrcode',
            name : 'ReportQrCode',
            component : ReportQrCode,
            meta : {
              menu : 'Reports',
              module : 'Report Suspect'
            }
          },{
            path : 'suspect',
            name : 'ReportSuspect',
            component : ReportSuspect,
            meta : {
              menu : 'Reports',
              module : 'QR Code'
            }
          },{
            path : 'summary-report',
            name : 'SummaryReport',
            component : SummaryReport,
            meta : {
              menu : 'Reports',
              module : 'Summary Report'
            }
          },{
            path : 'not-found-report',
            name : 'ReportNotFound',
            component : ReportNotFound,
            meta : {
              menu : 'Reports',
              module : 'Not Found Report'
            }
          }]
        },

        //Summary Report
        // {
        //   path : 'summary-report',
        //   component : SummaryReportMain,
        //   children : [{
        //     path : '',
        //     name : 'SummaryReport',
        //     component : SummaryReport
        //   },{
        //     path : 'summary-report',
        //     name : 'SummaryReport',
        //     component : SummaryReport,
        //     meta : {
        //       menu : 'SummaryReport',
        //       module : 'Summery Report'
        //     }
        //   }]
        // },

        //Settings
        {
          path : 'settings',
          component : SettingsMain,
          children : [{
            path : '',
            name : 'Settings',
            component : NotFound
          },{
            path : 'log-history-activity',
            name : 'LogHistoryActivity',
            component : LogHistoryActivity,
            meta : {
              menu : 'Settings',
              module : 'Log Dashboard Activity'
            }
          },{
            path : 'user-management',
            component : UserManagementMain,
            children : [{
              path : 'dashboard-user',
              name : 'DashboardUserManagement',
              component : DashboardUserUM,
              meta : {
                menu : 'Settings - User Management',
                module : 'Dashboard User'
              }
            },{
              path : 'oil-maker-app',
              name : 'OilMakerAppUserManagement',
              component : OilMakerAppUM,
              meta : {
                menu : 'Settings - User Management',
                module : 'Oil Maker App'
              }
            },{
              path : 'penindakan-app',
              name : 'PenindakanAppUserManagement',
              component : PenindakanAppUM,
              meta : {
                menu : 'Settings - User Management',
                module : 'Penindakan App'
              }
            }]
          }]
        },
      ],
      meta : {
        requiresAuth : true
      },
    },

    //Error 404 Page Not Found
    { 
      path: "*", 
      component: PageNotFound,
      meta : {
        requiresAuth : false
      }
    }


  ]
})

export default router;